import React from "react"

import { Box, Container, Grid, Image, Typography } from "src/UILibrary"
import { COPY_RIGHT } from "src/constants"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import FaceBookIcon from "src/assets/icons/facebook.png"
import TwitterIcon from "src/assets/icons/twitter.png"
import InstagramIcon from "src/assets/icons/instagram.png"
import "./footer.scss"
import { useMediaQuery } from "react-responsive"

const Footer = () => {
  const { t } = useTranslation("translation", { keyPrefix: "footer" })

  const navigate = useNavigate()

  const isPC = useMediaQuery({ query: "(min-width: 690px)" })

  return (
    <Box bgcolor="background.dark" className="footer">
      <Container maxWidth="md">
        <Box className="footer-container">
          <Box display="flex" className="footer-sns-container">
            <Image
              src={FaceBookIcon}
              width="40px"
              onClick={() =>
                window.open("https://www.facebook.com/profile.php?id=100088763422084", "_blank")
              }
              sx={{ "&:hover": { cursor: "pointer" } }}
            />
            <Image
              src={TwitterIcon}
              width="40px"
              sx={{ ml: "30px", "&:hover": { cursor: "pointer" } }}
              onClick={() => window.open("https://twitter.com/Takaoka_Startup", "_blank")}
            />
            <Image
              src={InstagramIcon}
              width="40px"
              sx={{ ml: "30px", "&:hover": { cursor: "pointer" } }}
              onClick={() => window.open("https://www.instagram.com/takaoka_stup/", "_blank")}
            />
          </Box>
          <Box className="footer-menu-container">
            <Box mr={isPC ? 3.75 : 0}>
              <Typography.SubTitle
                className="footer-menu"
                sx={{ "&:hover": { cursor: "pointer" } }}
                onClick={() => navigate("/faq")}
              >
                {t("FAQ")}
              </Typography.SubTitle>
              <Typography.SubTitle
                className="footer-menu"
                sx={{ "&:hover": { cursor: "pointer" } }}
                onClick={() => navigate("/adviser")}
              >
                {t("counselor_list")}
              </Typography.SubTitle>
              <Typography.SubTitle
                className="footer-menu"
                sx={{ "&:hover": { cursor: "pointer" } }}
                onClick={() => window.open("https://insight-group.co.jp/会社概要/", "_blank")}
              >
                {t("operator_information")}
              </Typography.SubTitle>
            </Box>
            <Box>
              <Typography.SubTitle
                className="footer-menu"
                sx={{ "&:hover": { cursor: "pointer" } }}
                onClick={() => navigate("/term_of_use")}
              >
                {t("terms_of_service")}
              </Typography.SubTitle>
              <Typography.SubTitle
                className="footer-menu"
                sx={{ "&:hover": { cursor: "pointer" } }}
                onClick={() => navigate("/privacy_policy")}
              >
                {t("site_policy")}
              </Typography.SubTitle>
              <Typography.SubTitle
                className="footer-menu"
                sx={{ "&:hover": { cursor: "pointer" } }}
                onClick={() => navigate("/contact")}
              >
                {t("contact")}
              </Typography.SubTitle>
            </Box>
          </Box>
        </Box>
      </Container>
      <Grid
        container
        justifyContent="center"
        bgcolor="background.dark"
        sx={{ display: { xs: "block", md: "flex" }, flexDirection: "row-reverse" }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "20%" },
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "center", md: "start" },
          }}
        >
          <Typography.Caption sx={{ color: "white", fontFamily: "Noto Sans JP !important" }}>
            {t("reconstruction_support")}
          </Typography.Caption>
        </Box>
        <Box sx={{ flexGrow: 1, justifyContent: "center", display: "flex" }}>
          <Typography.Caption
            display="inline-block"
            lineHeight={4}
            fontWeight={500}
            color="white"
            sx={{ fontFamily: "Noto Sans JP !important" }}
          >
            {COPY_RIGHT}
          </Typography.Caption>
        </Box>
        <Box sx={{ width: "20%" }} />
      </Grid>
    </Box>
  )
}

export default Footer
